import * as React from "react";

const SvgIcnUnderline = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
        <path
            d="M6.25 4.625a.625.625 0 10-1.25 0v5.321c0 1.554.508 2.615 1.419 3.565C7.33 14.46 8.5 15 10 15s2.67-.539 3.581-1.49C14.492 12.56 15 11.5 15 9.947V4.625a.625.625 0 10-1.25 0v5.321a3.835 3.835 0 01-1.07 2.699c-.683.71-1.68 1.105-2.68 1.105-1 0-1.997-.394-2.68-1.105a3.835 3.835 0 01-1.07-2.699V4.625zM4.625 16.375a.625.625 0 100 1.25h10.75a.625.625 0 100-1.25H4.625z"
            fill="currentColor"
        />
    </svg>
);

export default SvgIcnUnderline;
